module.exports = __webpack_public_path__ + "img/NR.8e98f9b2.svg";